export const ADS_ATTRIBUTION_MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000;

export type AdsAttribution = {
  ads_source: string;
  ads_captured_at: string;
  ads_campaign?: string;
  ads_medium?: string;
  ads_ad_id?: string;
  ads_oppref?: string;
};

// Flat, bounded string values also fit Stripe's metadata contract.
export function parseAdsAttribution(value: unknown, now = Date.now()): AdsAttribution | undefined {
  if (!value || typeof value !== "object" || Array.isArray(value)) return;
  const data = value as Record<string, unknown>;
  const { ads_source: source, ads_captured_at: capturedAtValue } = data;
  if (typeof source !== "string" || !source || source.length > 100) return;
  if (typeof capturedAtValue !== "string" || !/^\d{13}$/.test(capturedAtValue)) return;
  const capturedAt = Number(capturedAtValue);
  if (capturedAt > now + 600_000 || now - capturedAt > ADS_ATTRIBUTION_MAX_AGE_MS) return;
  const result: AdsAttribution = {
    ads_source: source,
    ads_captured_at: capturedAtValue,
  };
  for (const key of ["ads_campaign", "ads_medium", "ads_ad_id", "ads_oppref"] as const) {
    const field = data[key];
    if (field === undefined) continue;
    if (typeof field !== "string" || !field || field.length > (key === "ads_oppref" ? 400 : 100))
      return;
    result[key] = field;
  }
  return result;
}
